import React, { useState } from 'react';
import PageTopButton from '@components/common/pageTopButton';
import Intro from '@components/events/eventProfile/intro';
import HowTo from '@components/events/eventProfile/howTo';
import LastBanner from '@components/events/eventProfile/lastBanner';
import MatchingMessage from '@components/events/eventProfile/matchingMessage';
import Interviewee from '@components/events/eventProfile/interviewee';
import EventProfileFill, { ModalState } from './modal';

import Order from './order';
import ZipList from './zipList';
import classnames from 'classnames/bind';

import styles from './commonStyle.module.scss';
const cx = classnames.bind(styles);

const EventProfile = () => {
  const [modalState, setModalState] = useState<ModalState>(null);

  return (
    <div className={cx('wrap')}>
      {/* intro */}
      <Intro />

      {/* order */}
      <Order />

      {/* how to */}
      <HowTo />

      {/* ZipList */}
      <ZipList />

      {/* Matching Message */}
      <MatchingMessage />

      {/* Interviewee */}
      <Interviewee />

      {/* last Banner */}
      <LastBanner />

      <EventProfileFill modalState={modalState} setModalState={setModalState} />

      <PageTopButton />
    </div>
  );
};

export default EventProfile;
